/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */

/**
 * Type of animal
 */
export type ImportReportDtoAnimalType =
  (typeof ImportReportDtoAnimalType)[keyof typeof ImportReportDtoAnimalType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ImportReportDtoAnimalType = {
  vertebrate: 'vertebrate',
  invertebrate: 'invertebrate',
} as const;
